module.exports = __webpack_public_path__ + "static/media/roger-keller.2dda6c84.jpg";